export default __webpack_public_path__ + "locales/lo-LA/MainBar.json?hash=b793c109f80c6466ee03360c47d579df";